module.exports = __webpack_public_path__ + "img/Picture5.1ebf4924.png";